type articleType = {
  full?: boolean;
};

export const getWidth = ({ full }: articleType) => (full ? `width: 100%;` : '');
